import { Select } from "@xola/ui-kit";
import { FormField, getDuration } from "common";
import { useFormikContext } from "formik";
import pluralize from "pluralize";
import React, { useEffect, useState } from "react";
import { OffsetDurationUnit } from "../../../../helpers/durationHelper";
import { PackageFormValues } from "../../Packages/DescriptiveContent/StartTimeRestriction";
import { NumberInput } from "@/components/Common/NumberInput";

export const PartnerMinimumDurationField = () => {
    const { values, setFieldValue } = useFormikContext<PackageFormValues>();
    const { minimumTransitDuration } = values;
    const durationUnit = getDuration(minimumTransitDuration);

    const [value, setValue] = useState(minimumTransitDuration);

    useEffect(() => {
        setValue(minimumTransitDuration);
    }, [minimumTransitDuration]);

    const handleChangeValue = (newValue: number) => {
        setValue(newValue);
        setFieldValue("minimumTransitDuration", newValue);
    };

    const handleUnitChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setFieldValue("durationUnit", e.target.value as OffsetDurationUnit);
    };

    return (
        <FormField
            name="durationBetweenEvents"
            label="Duration Between Events"
            tooltip="Enable to require a minimum amount of time between the end of one event and the start of another."
            placement="top"
        >
            <div className="flex items-center">
                <NumberInput
                    value={value}
                    className="h-10 w-full rounded-br-none rounded-tr-none border-r-0"
                    onChange={handleChangeValue}
                />
                <div className="w-30">
                    <Select
                        name="durationUnit"
                        className="h-10 rounded-bl-none rounded-tl-none"
                        value={durationUnit.unit}
                        onChange={handleUnitChange}
                    >
                        {[OffsetDurationUnit.DAYS, OffsetDurationUnit.HOURS, OffsetDurationUnit.MINUTES].map(
                            (option) => (
                                <option key={option} value={option}>
                                    {pluralize(option, 2)}
                                </option>
                            ),
                        )}
                    </Select>
                </div>
            </div>
        </FormField>
    );
};
